import ErrorBoundary from 'components/ErrorBoundary';
import { AppThemeProvider } from 'context-providers/AppTheme';
import { AppRoutes } from 'routing/AppRoutes';

interface Props {}

const App = (props: Props) => {
  return (
    <AppThemeProvider>
      <ErrorBoundary>
        <AppRoutes />
      </ErrorBoundary>
    </AppThemeProvider>
  );
};

export default App;
